import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SbIcons } from '@ngx-seatback/icons';
import { NamedIdentityDTO } from '../../services/api/api';

@Component({
  selector: 'sb-comp-selection',
  templateUrl: './selection.component.html',
  styleUrls: ['./selection.component.scss'],
  standalone: false,
})
export class SelectionComponent {
  @Input({ required: true }) display: NamedIdentityDTO;
  @Input() hideCreate: boolean;
  @Input() hideAll: boolean;
  @Input() emptyString: string;
  @Input() icon: SbIcons | string;

  @Output() selectClicked: EventEmitter<boolean>;
  @Output() createClicked: EventEmitter<boolean>;
  @Output() deleteClicked: EventEmitter<boolean>;

  constructor() {
    this.emptyString = '-';
    this.hideCreate = false;
    this.deleteClicked = new EventEmitter<boolean>();
    this.createClicked = new EventEmitter<boolean>();
    this.selectClicked = new EventEmitter<boolean>();
  }
}
